/**
 * Builds a WhatsApp redirect URL based on bot information
 * @param {Object} bot - The WhatsApp bot object
 * @param {boolean} bot.is_community_redirect - Whether to use community link
 * @param {string} bot.community_link - Community link URL
 * @param {string} bot.number - WhatsApp number
 * @param {string} bot.message - Pre-filled message
 * @returns {string} The WhatsApp redirect URL
 */
export function buildWhatsAppUrl(bot) {
  if (bot.is_community_redirect && bot.community_link) {
    return bot.community_link
  }

  const baseUrl = `https://wa.me/${bot.number}`
  if (bot.message) {
    const encodedMessage = encodeURIComponent(bot.message)
    return `${baseUrl}?text=${encodedMessage}`
  }
  return baseUrl
}
